import { render } from "./UnitInfo__sensors.vue?vue&type=template&id=bd6a3d2a&scoped=true"
import script from "./UnitInfo__sensors.vue?vue&type=script&lang=js"
export * from "./UnitInfo__sensors.vue?vue&type=script&lang=js"

import "./UnitInfo__sensors.vue?vue&type=style&index=0&id=bd6a3d2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6a3d2a"]])

export default __exports__